
export const locale = {
  'DIALOG' : {
    'CREATE_MANAGER' : {
      'TITLE' : {
        'CREATE' : 'Create manager',
        'EDIT' : 'Edit manager',
      },
      'CONFIRMBUTTON' : {
        'CREATE' : 'Create',
        'SAVE' : 'Save',
      },
      'FULLNAME' : 'Full name',
    },
    'ERROR' : {
      'ALREADYEXISTS' : 'Account already exists for this username.',
    }
  },
};
